<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <user-field-type-options-edit-form
        @on-submit="onUserFieldTypeOptionsEditSubmit"
      ></user-field-type-options-edit-form>
    </div>
  </div>
</template>
<script>
import UserFieldTypeOptionsEditForm from "./UserFieldTypeOptionsEditForm.vue";

export default {
  components: {
    UserFieldTypeOptionsEditForm
  },
  data() {
    return {
      userFieldTypeOptionsEditModel: {}
    };
  },
  methods: {
    onUserFieldTypeOptionsEditSubmit(model) {
      this.userFieldTypeOptionsEditModel = model;
      // this.$http.post(
      //   this.$apiBaseUrl + 'users/field/type/options/' + this.userFieldTypeOptionsEditModel.id, Object.assign(this.userFieldTypeOptionsEditModel)
      // ).then(response => {
      // }, response => {
      // });
    }
  }
};
</script>
<style></style>
